import loader from "vue-ui-preloader";
import Vue from "vue";
Vue.use(loader);
